import React from 'react';
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';
import Confirm from '../popup/ConfirmActionPopup.component';
import AddSubstitute from '../popup/AddSubstitutePopUp.component';
import translate from '../translations/translations.wrapper.jsx';
import ConfigurationWrapper from '../configuration/ConfigurationWrapper.component';
import SearchGroupInput from "../input/SearchGroupInput.component";
import "./substitutes.scss";
import ListWithActions from "../listWithActions/ListWithActions.component";
import { SegmentedControl } from "components/common/SegmentedControl.component";
import {
    changeActiveFilter,
    changeSearchValue,
    getSubstitutes,
    deleteSubstitute,
    changeSort
} from './substitutes.action';
import {formatDate} from "utils/valueFormatter.function";
import {formatNameWithEmail} from "utils/userFormatter.function";
import { LOADING_STATUS, MODAL_ACTIONS } from "utils/constants";
import * as _ from 'lodash';
import { Button, ButtonType } from "components/common/Button.component";
import { Loader, LoaderSize } from "components/common/Loader.component.tsx";
import { launchDarkly } from "utils/launchDarkly";
import { useModalContext } from "components/modals/ModalContext";

const TODAY = new Date().setHours(0, 0, 0, 0);
const NOT_ASSIGNED = "N/A";

const STATUS_FILTER = {
    ALL: "all",
    CURRENT: "current",
    UPCOMING: "upcoming"
};
let stopScroll = false;
const FIRST_PAGE = 1;

export class Substitutes extends ConfigurationWrapper {

    constructor(props) {
        super(props);
        this.state = {
            selectedSubstitute: null,
            confirmDelete: false,
            rowToDelete: null,
            showSubstitutePopUp: false
        };

        this.buildList = this.buildList.bind(this);

        this.clearSearch = this.clearSearch.bind(this);
        this.closeDeletePopUp = this.closeDeletePopUp.bind(this);
        this.closeSubstitutePopUp = this.closeSubstitutePopUp.bind(this);
        this.computeHeader = this.computeHeader.bind(this);
        this.computeStatus = this.computeStatus.bind(this);

        this.deleteRow = this.deleteRow.bind(this);
        this.editRow = this.editRow.bind(this);
        this.filter = this.filter.bind(this);
        this.getData = this.getData.bind(this);

        this.loadMoreItems = this.loadMoreItems.bind(this);
        this.openAddSubstitutePopUp = this.openAddSubstitutePopUp.bind(this);

        this.removeRow = this.removeRow.bind(this);
        this.saveCloseCallback=this.saveCloseCallback.bind(this);
        this.resetFilterToAll = this.resetFilterToAll.bind(this);
        this.search = this.search.bind(this);
        this.sort = this.sort.bind(this);
    }

    componentDidMount(props) {
        super.componentDidMount(props);
        this.computeHeader();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (this.props.userRoles.systemAdministrator !== prevProps.userRoles.systemAdministrator) {
            this.computeHeader();
        }
    }

    getData() {
        this.props.getSubstitutes(FIRST_PAGE, this.props.activeFilter, this.props.searchValue, this.props.sort);
    }

    buildList() {
        stopScroll = false;
        return this.props.substitutes && this.props.substitutes.allSubstitutes ? this.props.substitutes.allSubstitutes.map(sub => {
            let fromDate = sub.from ? new Date(sub.from).setHours(0, 0, 0, 0) : null;
            let toDate = sub.to ? new Date(sub.to).setHours(0, 0, 0, 0) : null;
            let status = this.computeStatus(fromDate);


            // Parse userName to split name and email
            const userDisplay = formatNameWithEmail(sub.userName);

            // Parse substituteName to split name and email
            let substituteDisplay = "";
            if (sub.substituteName && sub.substituteName !== NOT_ASSIGNED) {
                substituteDisplay = formatNameWithEmail(sub.substituteName);
            }

            return {
                user: userDisplay,
                userId: sub.userId,
                substituteId: sub.substituteId,
                substitute: substituteDisplay,
                notBefore: formatDate(fromDate),
                notAfter: toDate ? formatDate(toDate) : (sub.from ? this.props.translate("substitutes.indefinitely") : "-"),
                status: status,
                version: sub.version
            };
        }) : [];
    }

    clearSearch() {
        this.props.changeSearchValue("");
        this.props.getSubstitutes(this.props.substitutes.page, this.props.activeFilter, "", this.props.sort, true);
    }

    closeDeletePopUp() {
        this.setState({
            confirmDelete: false
        });
    }

    closeSubstitutePopUp() {
        this.setState({
            showSubstitutePopUp: false
        });
        this.props.getSubstitutes(FIRST_PAGE, this.props.activeFilter, "", this.props.sort,true);
    }

    computeStatus(fromDate) {
        //no start date -> not current, not upcoming
        if (fromDate === null)
            return "";

        return (fromDate <= TODAY) ? this.props.translate("substitutes.active") : this.props.translate("substitutes.planned");

    }

    computeHeader() {
        //there is no action column, so we can make the name columns bigger
        //const largeNames = !this.props.userRoles.systemAdministrator;

        let header = [
            {
                value: "user",
                text: "substitutes.headers.user",
                class: "col-md-3",
                sortable: true
            },
            {
                value: "substitute",
                text: "substitutes.headers.substitute",
                class: "col-md-3",
                sortable: true
            },
            {
                value: "notBefore",
                text: "substitutes.headers.notBefore",
                class: "col-md-2",
                sortable: true
            },
            {
                value: "notAfter",
                text: "substitutes.headers.notAfter",
                class: "col-md-2",
                sortable: true
            },
            {
                value: "status",
                text: "substitutes.headers.status",
                class: "col-md-1"
            }
        ];

        this.setState({
            header: header
        });

    }

    deleteRow(rowId) {
        if (this.props.useNewModals && this.props.toggleModal) {
            this.setState({rowToDelete: rowId}, () => {
                this.props.toggleModal(MODAL_ACTIONS.CONFIRM_ACTION, {
                    title: this.props.translate("popUp.deleteSubstitute.title"),
                    message: this.props.translate("substitutes.confirmDelete", this.props.substitutes.allSubstitutes[rowId].substituteName, this.props.substitutes.allSubstitutes[rowId].userName),
                    handleAction: () => {
                        this.props.toggleModal(null);
                        this.removeRow();
                    },
                });
            });
        } else {
            this.setState({
                confirmDelete: true,
                rowToDelete: rowId
            });
        }
    }

    editRow(rowIndex) {
        const selected = this.props.substitutes.allSubstitutes[rowIndex];
        if (this.props.useNewModals && this.props.toggleModal) {
            this.props.toggleModal(MODAL_ACTIONS.EDIT_SUBSTITUTE, {
                edit: selected,
                saveCloseCallback: this.resetFilterToAll,
                closeCallback: this.closeSubstitutePopUp,
            });
            return;
        }
        this.setState({
            selectedSubstitute: selected,
            showSubstitutePopUp: true
        });
    }

    filter(value) {
        this.props.changeActiveFilter(value);
        this.props.getSubstitutes(this.props.substitutes.page, value, this.props.searchValue, this.props.sort, true);
    }

    loadMoreItems() {
        if (!stopScroll) {
            let {allSubstitutes, records, page} = this.props.substitutes;
            stopScroll = true;
            if (allSubstitutes.length > 0 && allSubstitutes.length < records) {
                this.props.getSubstitutes(page + 1, this.props.activeFilter, this.props.searchValue, this.props.sort, true);
            }
        }
    }


    openAddSubstitutePopUp() {
        if (this.props.useNewModals && this.props.toggleModal) {
            this.props.toggleModal(MODAL_ACTIONS.ADD_SUBSTITUTE, {
                saveCloseCallback: this.resetFilterToAll,
                closeCallback: this.closeSubstitutePopUp,
            });
            return;
        }
        this.setState({
            selectedSubstitute: null,
            showSubstitutePopUp: true
        });
    }

    removeRow() {
        this.setState({
            confirmDelete: false
        });
        this.props.deleteSubstitute(this.state.rowToDelete);
        this.props.getSubstitutes(this.props.substitutes.page, this.props.activeFilter, this.props.searchValue, this.props.sort, true);
    }

    saveCloseCallback(){
        this.props.changeActiveFilter(STATUS_FILTER.ALL);
        this.closeSubstitutePopUp();
    }

    resetFilterToAll(){
        this.props.changeActiveFilter(STATUS_FILTER.ALL);
    }

    search(event) {
        this.props.changeSearchValue(event.target.value);
        this.props.getSubstitutes(this.props.substitutes.page, this.props.activeFilter, event.target.value, this.props.sort, true);
    }

    sort(column) {
        let currentHeader = _.cloneDeep(this.state.header);
        let newSort = {
            fieldName: currentHeader[column].value,
            sortOrder: true
        };

        let currentSort = Object.assign({}, this.props.sort);
        if (currentSort.fieldName === newSort.fieldName) {
            newSort.sortOrder = !currentSort.sortOrder;
        }

        currentHeader.forEach((header, index) => {
            //pressed column header
            if (index === column) {
                if (header.sortable) {
                    header.sortOrder = newSort.sortOrder ? "up" : "down";
                }
            }
            else {
                delete header.sortOrder;
            }
        });

        this.props.changeSort(newSort);
        this.props.getSubstitutes(this.props.substitutes.page, this.props.activeFilter, this.props.searchValue, newSort, true);

        this.setState({
            header: currentHeader
        });

    }

    buildContent() {
        return (
            <main className="page w-100 mt-48 overflow-y-auto d-flex justify-content-center align-items-start">
                <div className="py-16 mb-48 w-75 settings-page__container">
                    {this.state.confirmDelete && !this.props.useNewModals &&
                    <Confirm translate={this.props.translate}
                             popUpType={"deleteSubstitute"}
                             message={this.props.translate("substitutes.confirmDelete", this.props.substitutes.allSubstitutes[this.state.rowToDelete].substituteName, this.props.substitutes.allSubstitutes[this.state.rowToDelete].userName)}
                             handleAction={this.removeRow} closeCallback={this.closeDeletePopUp}/>
                    }

                    {this.state.showSubstitutePopUp && !this.props.useNewModals &&
                    <AddSubstitute translate={this.props.translate}
                                   edit={this.state.selectedSubstitute}
                                   saveCloseCallback={this.saveCloseCallback}
                                   closeCallback={this.closeSubstitutePopUp}/>
                    }

                    <h2 className="ps-4 mb-4 d-flex align-items-center">{this.props.translate("substitutes.header")}
                        <span className="ms-4"
                              data-tooltip-info__bottom={this.props.translate("substitutes.headerInfo")}>
                            <CircleQuestionMark size={ICON_SIZE.MEDIUM}/>
                        </span>
                    </h2>

                    <div className="bg-white radius-4 p-4 setting_collapsable-main">
                        <StatusFilters translate={this.props.translate}
                                       newSubstitution={this.openAddSubstitutePopUp}
                                       filter={this.filter}
                                       canAddSubstitute={this.props.userRoles.systemAdministrator}
                                       activeFilter={this.props.activeFilter}
                                       search={this.search}
                                       searchValue={this.props.searchValue}
                                       clearSearch={this.clearSearch}/>

                        {this.props.loadingStatus === LOADING_STATUS.DONE &&
                            <ListWithActions header={this.state.header}
                                             values={this.buildList()}
                                             sortHandle={this.sort}
                                             deleteRow={this.deleteRow}
                                             editRow={this.editRow}
                                             sortColumn={this.props.sort}
                                             scrollAtBottom={this.loadMoreItems}
                                             showActions={this.props.userRoles.systemAdministrator}
                                             translate={this.props.translate}/>
                        }

                        {this.props.loadingStatus === LOADING_STATUS.LOADING &&
                            <Loader size={LoaderSize.Medium} />
                        }
                    </div>
                </div>
            </main>
        )
    }
}

const withTranslations = translate(Substitutes);
const mapStateToProps = function (store) {
    return {
        currentContextId: reduxSelectors.getUsersCurrentContextId(store),
        userRoles: reduxSelectors.getUsersRoles(store),
        activeFilter: reduxSelectors.getSubstitutesActiveFilter(store),
        searchValue: reduxSelectors.getSubstitutesSearchValue(store),
        substitutes: reduxSelectors.getSubstitutesForRender(store),
        sort: reduxSelectors.getSubstitutesSorting(store),
        loadingStatus: reduxSelectors.getSubstitutesLoadingStatus(store)
    };
};

const Connected = connect(mapStateToProps, {
    changeActiveFilter,
    changeSearchValue,
    getSubstitutes,
    deleteSubstitute,
    changeSort
})(withTranslations);

const SubstitutesWithModal = (props) => {
    const useNewModals = launchDarkly.companyClient?.variation("use-new-modals", false);
    const modalContext = useModalContext();
    const {toggleModal} = modalContext || {};
    return <Connected {...props} useNewModals={useNewModals} toggleModal={toggleModal} />;
};

export default SubstitutesWithModal;

const StatusFilters = (props) => {
    return (
        <div className="d-flex justify-content-between mb-24">
            <div>
                {props.canAddSubstitute &&
                <div className="btn-group">
                    <Button type={ButtonType.PRIMARY}
                            onClick={props.newSubstitution}
                            text={props.translate("substitutes.newSubstitute")}
                    />
                </div>
                }
            </div>

            <div className="d-flex gap-3 align-items-center">
                <SearchGroupInput onInputChange={props.search}
                                  placeholder={props.translate("popUp.addSubstitute.name")}
                                  value={props.searchValue}
                                  className="ga-input__default"
                                  onClearInput={props.clearSearch}
                                  translate={props.translate}/>

                <SegmentedControl
                    options={[
                        {
                            key: STATUS_FILTER.ALL,
                            label: props.translate("substitutes.all"),
                            isSelected: props.activeFilter === STATUS_FILTER.ALL,
                            onClick: () => props.filter(STATUS_FILTER.ALL)
                        },
                        {
                            key: STATUS_FILTER.CURRENT,
                            label: props.translate("substitutes.active"),
                            isSelected: props.activeFilter === STATUS_FILTER.CURRENT,
                            onClick: () => props.filter(STATUS_FILTER.CURRENT)
                        },
                        {
                            key: STATUS_FILTER.UPCOMING,
                            label: props.translate("substitutes.planned"),
                            isSelected: props.activeFilter === STATUS_FILTER.UPCOMING,
                            onClick: () => props.filter(STATUS_FILTER.UPCOMING)
                        }
                    ]}
                />
            </div>
        </div>

    );
};